'use strict';

angular.module('bringgApp').controller('clientLogoutController', function (Authentication, SingleSignOn) {
	SingleSignOn.clearSSOIdentifiers();
	Authentication.logout();
});
